
export default {
  props: { pageName: { type: Array, default: () => [] } },

  computed: {
    leafLink() {
      if (this.$route.params.tag) {
        return this.$route.params.tag;
      }

      if (this.pageName && this.pageName[0]) {
        return this.pageName[0].text;
      }

      return "";
    },
  },
};
